define('sdb_modal_content.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('sdb_modal_content', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<div> "
    + ((stack1 = _nl_(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? _nl_(depth0,"hasContentView") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.program(3, data, 0),"data":data,"loc":{"start":{"line":1,"column":6},"end":{"line":1,"column":94}}})) != null ? stack1 : "")
    + " </div>";
},"1":function(container,depth0,helpers,partials,data) {
    return " <div data-view=\"Content.View\"></div> ";
},"3":function(container,depth0,helpers,partials,data) {
    return " Empty Modal ";
},"useData":true}, 'extensions/SuiteDB/SDBSelectYourVehicle/1.6.2/', 'extensions/SuiteDB/SDBSelectYourVehicle/1.6.2/', Handlebars);
});